import { render, staticRenderFns } from "./RestorePasswordForm.vue?vue&type=template&id=348326cb&scoped=true&lang=pug"
import script from "./RestorePasswordForm.vue?vue&type=script&lang=ts"
export * from "./RestorePasswordForm.vue?vue&type=script&lang=ts"
import style0 from "./RestorePasswordForm.vue?vue&type=style&index=0&id=348326cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348326cb",
  null
  
)

export default component.exports